import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUser } from '../../../contexts/UserContext';
import { useLanguage } from '../../../contexts/LanguageContext';
import { hapticFeedback } from '../../../utils/telegram';
import homeLogo from '../../../assets/icons/home-logo.svg';
import licenceLogo from '../../../assets/icons/licension-logo.svg';
import referralLogo from '../../../assets/icons/referal-logo.svg';
import transactionLogo from '../../../assets/icons/transaction-logo.svg';
import toolsLogo from '../../../assets/icons/tools-logo.svg';
import './Navigation.css';
import { useConfig } from '../../../hooks/useConfig';

const Navigation = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user } = useUser();
  const { t } = useLanguage();
  const config = useConfig();
  
  // Navigation items with translation keys
  const NAV_ITEMS = [
    {
      id: 'dashboard',
      labelKey: 'dashboard',
      path: '/',
      icon: homeLogo
    },
    {
      id: 'transactions',
      labelKey: 'transactions',
      path: '/transactions',
      icon: transactionLogo
    },
    {
      id: 'arbitrage',
      labelKey: 'arbitrage',
      path: '/arbitrage',
      icon: config.logo
    },
    {
      id: 'licenses',
      labelKey: 'licenses',
      path: '/licenses',
      icon: licenceLogo
    },
    {
      id: 'referrals',
      labelKey: 'referrals',
      path: '/referrals',
      icon: referralLogo
    }
  ];
  
  const handleNavClick = (path) => {
    hapticFeedback.light();
    
    // Scroll to top immediately for all navigation actions
    window.scrollTo(0, 0);
    
    // If we're not on the page being clicked, navigate to it
    if (pathname !== path) {
      navigate(path);
    }
  };

  // Check if user is admin
  const adminIds = ['569452912', '5982701507'];
  const isAdmin = user && adminIds.includes(user.telegramId); // Replace with proper admin check

  // Create navigation items with admin item if user is admin
  const navigationItems = [...NAV_ITEMS];
  if (isAdmin) {
    navigationItems.push({
      id: 'admin',
      labelKey: 'admin',
      path: '/admin',
      icon: toolsLogo
    });
  }
  
  return (
    <nav className="navigation">
      {navigationItems.map((item) => (
        <div
          key={item.id}
          className={`nav-item ${pathname === item.path ? 'active' : ''}`}
          onClick={() => handleNavClick(item.path)}
        >
          <img src={item.icon} alt={t(item.labelKey)} className="nav-icon" />
          <span className="nav-label">{t(item.labelKey)}</span>
        </div>
      ))}
    </nav>
  );
};

export default Navigation; 